export interface ProductEconomics {
  purchaseUnit: 'piece' | 'set';
  purchaseQuantity: string;
  purchasePrice: string;
  saleQuantity: string;
}
export const emptyProductEconomics: ProductEconomics = { purchaseUnit: 'piece', purchaseQuantity: '1', purchasePrice: '', saleQuantity: '1' };
export function parseProductEconomics(raw: unknown): ProductEconomics {
  if (typeof raw === 'string') {
    try { return parseProductEconomics(JSON.parse(raw)); }
    catch { return { ...emptyProductEconomics, purchasePrice: raw }; }
  }
  if (typeof raw === 'number') return { ...emptyProductEconomics, purchasePrice: String(raw) };
  if (!raw || typeof raw !== 'object') return { ...emptyProductEconomics };
  const data = raw as Record<string, unknown>;
  return {
    purchaseUnit: data.purchaseUnit === 'set' ? 'set' : 'piece',
    purchaseQuantity: String(data.purchaseQuantity ?? '1'),
    purchasePrice: String(data.purchasePrice ?? ''),
    saleQuantity: String(data.saleQuantity ?? '1'),
  };
}
export function calculateProductEconomics(data: ProductEconomics) {
  const price = Number(data.purchasePrice.replace(',', '.'));
  const purchaseQuantity = data.purchaseUnit === 'piece' ? 1 : Number(data.purchaseQuantity);
  const saleQuantity = Number(data.saleQuantity);
  if (!data.purchasePrice.trim() || !Number.isFinite(price) || price < 0 || !Number.isInteger(purchaseQuantity) || purchaseQuantity < 1 || !Number.isInteger(saleQuantity) || saleQuantity < 1) return null;
  return { costPerPiece: price / purchaseQuantity, costPerSaleUnit: Math.round(price * saleQuantity / purchaseQuantity * 100) / 100 };
}
export function serializeProductEconomics(data: ProductEconomics) {
  return { ...data, purchaseQuantity: data.purchaseUnit === 'piece' ? '1' : data.purchaseQuantity, ...calculateProductEconomics(data) };
}

/** Shared purchase terms win; a bundle supplies only its sale quantity. */
export function bundleEconomics(purchase: unknown, bundle: unknown): ProductEconomics {
  const own = parseProductEconomics(bundle);
  const shared = parseProductEconomics(purchase);
  return shared.purchasePrice.trim() ? { ...shared, saleQuantity: own.saleQuantity } : own;
}

export function normalizeBriefEconomics(values: Record<string, string>, packageFields: string[]): Record<string, string> {
  const result = { ...values };
  for (const key of packageFields) {
    try {
      const rows: unknown = JSON.parse(values[key] || '');
      if (!Array.isArray(rows)) continue;
      result[key] = JSON.stringify(rows.map(row => {
        if (!row || typeof row !== 'object') return row;
        const economics = bundleEconomics(values.product_unit_cost, row.economics);
        return { ...row, economics: serializeProductEconomics(economics) };
      }));
    } catch { /* Preserve legacy free-text packages. */ }
  }
  return result;
}
